import { contains, reject, map } from 'ramda';
import { lookup } from 'mime-types';
import { FileWithMMGRFolderId } from './fileEntry.types';

const DENYLIST = ['.DS_Store', 'thumbs.db', 'desktop.ini'];

export const applyDenyList = (fileList: File[]) => reject((file) => contains(file.name, DENYLIST), fileList);

export const fixEmptyTypes = (fileList: FileWithMMGRFolderId[]) =>
  // mime type can be empty in Chrome sometimes, trying to guess by file name
  map((file) => {
    const f = (
      file.type ? file : new File([file], file.name, { type: lookup(file.name) || '' })
    ) as FileWithMMGRFolderId;
    if (file.mmgrFolderId) {
      f.mmgrFolderId = file.mmgrFolderId;
    }
    return f;
  }, fileList);
